import React from 'react'
import PropTypes from 'prop-types'
import { colors } from '@lmc/common/constants'
import { LabelIcon, ListItem } from '../../../../../components/generic'
import StockAlertIcon from './StockAlertIcon'
import { getShowAlert, getStockText, getSubLabel } from './utils'

const renderLabel = (props) => {
  const { showAlert } = props

  const textStyle = {
    ...styles.stockText,
    color: showAlert ? colors.red : colors.black,
  }

  return (
    <div style={styles.label}>
      <div style={textStyle}>{getStockText(props)}</div>
    </div>
  )
}

const renderRight = (props) => {
  const { medication } = props

  const showAlert = getShowAlert(medication)

  return (
    <LabelIcon
      iconPosition="right"
      label={renderLabel({ ...props, showAlert })}
      renderCustomIcon={() => <StockAlertIcon medication={medication} />}
    />
  )
}

export default function StockListItem(props) {
  const { label, medication, residentId, icon } = props
  const { name, stockLog } = medication
  return (
    <ListItem
      iconColor={colors.blue}
      icon={icon}
      label={label || name}
      renderRight={() => stockLog && renderRight(props)}
      subLabel={stockLog && getSubLabel(stockLog)}
      to={`/residents/${residentId}/emar/${medication.id}/stock`}
    />
  )
}

StockListItem.propTypes = {
  label: PropTypes.string,
  medication: PropTypes.object.isRequired,
  residentId: PropTypes.string.isRequired,
}

const styles = {
  icon: {
    height: 24,
    marginLeft: 10,
  },
  label: {
    alignItems: 'flex-end',
    display: 'flex',
    flexDirection: 'column',
  },
  rightContainer: {
    display: 'flex',
  },
  stockText: {
    lineHeight: '22px',
  },
  updatedText: {
    color: colors.darkgrey,
    lineHeight: '22px',
  },
}
